module.exports = __webpack_public_path__ + "img/very_good.79e86b21.svg";